module.exports = __webpack_public_path__ + "img/04.aab02910.jpg";